import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { NumberSequencesDataGrid } from "src/components/views/erp/common/numberSequences/NumberSequencesDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/common/numberSequences")({
	staticData: { title: i18n.t("number_sequences"), legacyViewKey: "numberSequencesPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <NumberSequencesDataGrid />;
}
